import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn";

/**
 * A placeholder bar. On its own it breathes (`skeleton-pulse`). Inside a
 * `.skeleton-sheen` container it holds still and the container's light sweep
 * carries the motion instead: a bar that is mid-breath when the real content
 * swaps in reads as a brightness blink, and every swap is a hard cut where
 * view transitions are off (WebKit), so skeletons that stand in for a whole
 * page wrap their cards in `skeleton-sheen` and keep the bars static.
 */
export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "skeleton-bar rounded-md bg-mist",
        "animate-[skeleton-pulse_2s_ease-in-out_infinite]",
        "motion-reduce:animate-none",
        className,
      )}
      {...rest}
    />
  );
}
